import { LogOut } from "lucide-react";
import { useTranslation } from "react-i18next";

import { LocaleSwitcher } from "@/components/LocaleSwitcher";
import { useAuth } from "../../features/auth/authContext";

export function Topbar() {
  const { user, signOut } = useAuth();
  const { t } = useTranslation(["auth", "common"]);

  return (
    <header className="flex h-14 items-center justify-between border-b border-slate-200 bg-white px-6">
      <div className="text-sm text-slate-500">
        {user?.email
          ? t("auth:welcomeBackEmail", { email: user.email })
          : t("auth:welcomeBack")}
      </div>
      <div className="flex items-center gap-3">
        <LocaleSwitcher />
        <button
          type="button"
          onClick={signOut}
          className="inline-flex items-center gap-2 rounded-md px-3 py-1.5 text-sm font-medium text-slate-600 hover:bg-slate-100"
        >
          <LogOut className="h-4 w-4" />
          {t("common:actions.signOut")}
        </button>
      </div>
    </header>
  );
}
